export default {
      id: "icon--memberships-usage",
      viewBox: "0 0 32 30.8",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--memberships-usage",
      toString: function () {
        return this.url;
      }
    }